/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-header.get-names.ts 
*/
.ace-header {
  box-sizing: border-box;
  display: block;
  overflow-x: visible;
  width: 100%;
}
.ace-header * {
  box-sizing: border-box;
}
.ace-header__navbar {
  align-items: center;
  background-color: var(--ace-color-semantic-navigation-background);
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  display: flex;
  flex-direction: row;
  height: var(--ace-semantic-navigation-header-height-mobile);
  justify-content: space-between;
}
@media only screen and (min-width: 595px) {
  .ace-header__navbar {
    height: var(--ace-semantic-navigation-header-height-tablet);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-header__navbar {
    height: var(--ace-semantic-navigation-header-height-desktop);
  }
}
.ace-header__navigation {
  align-items: center;
  display: flex;
  height: 100%;
}
.ace-header__logo-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: flex-start;
}
.ace-header__logo:focus-visible {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
}
.ace-header__logo ::slotted(*) {
  width: 100%;
}
.ace-header__menu {
  align-items: center;
  display: flex;
  height: 100%;
}
.ace-header__right-menu {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-end;
}
.ace-header__actions-wrapper {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-start;
}
.ace-header__profile-button, .ace-header__help-button {
  display: none;
}
@media only screen and (min-width: 595px) {
  .ace-header__profile-button, .ace-header__help-button {
    display: block;
  }
}
.ace-header__offcanvas-menu {
  position: fixed;
  right: -31.25rem;
  top: 0;
  transition: 200ms ease-in;
  visibility: hidden;
  width: 100%;
  z-index: 14;
}
.ace-header__offcanvas-menu--show {
  right: 0;
  transition: 200ms ease-in;
  visibility: visible;
}
@media only screen and (min-width: 1025px) {
  .ace-header__offcanvas-menu {
    width: 25rem;
  }
}
.ace-header__search--within-submenu {
  display: block;
}
@media only screen and (min-width: 1025px) {
  .ace-header__search--within-submenu {
    display: none;
  }
}
.ace-header__search--within-navigation {
  display: none;
}
@media only screen and (min-width: 1025px) {
  .ace-header__search--within-navigation {
    display: block;
    width: 25rem;
  }
}
.ace-header__hidden-on-search-open {
  display: none !important;
}
.ace-header__submenu {
  background-color: var(--ace-color-surface-solid--100);
  display: flex;
}
.ace-header__search-results {
  display: none;
}
.ace-header__search-results--visible {
  display: block;
}

@keyframes halo-pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  57.14% {
    opacity: 1;
    transform: scale(2.5);
  }
  85.71% {
    opacity: 0;
    transform: scale(2.5);
  }
  92.86% {
    opacity: 0;
    transform: scale(1.75);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes dot-pulse {
  0% {
    transform: scale(1);
  }
  57.14% {
    transform: scale(1.3);
  }
  85.71% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}